<!-- eslint-disable no-useless-escape -->

<template>
     <div class="download-container ignore">

        <div style="position:fixed;top:0;width:100%;background:#333333;padding:20px 20px;">
            <span style="color:#F00;font-weight:bold;font-size:18px;">
                注意：当前下载地址仅供公司内部人员使用，不能用于推广/交付客户，一旦使用，后果自负！！
            </span>
        </div>

        <!--提示框,PC端会展示-->
        <div v-if="isH5Tip" class="h5-tip h5-tip-active">
            <div class="h5-tip-left">当前为PC浏览器,PC浏览器下无法安装APP,请用手机浏览器打开</div>
            <div class="h5-tip-right">
                <img src="./images/img_icon_arrow.jpg" />
            </div>
        </div>
        <div class="top-bg"></div>
        <div class="content ignore">
            <div class="content-div">
                <div class="app-logo">
                    <img :src="downloadInfo.iconurl" />
                </div>
                <div class="mobile-work"> {{ downloadInfo.name }}</div>

                <div class="app-info"  >
                    <van-skeleton :loading="donwloadInfoPosting" round class="this-skeleton"  :row="3" >
                            <div class="info-title">
                            <div class="info-label">
                                <span>版</span>
                                <span>本:</span>
                            </div>
                            <div class="info-label">
                                <span>大</span>
                                <span>小:</span>
                            </div>
                            <div class="info-label">
                                <span>更</span>
                                <span>新</span>
                                <span>时</span>
                                <span>间:</span>
                            </div>
                        </div>
                        <div class="info-value">
                            <div class="info-value-label" >
                                {{ downloadInfo.version }}
                            </div>
                            <div class="info-value-label" >
                                {{ downloadInfo.RAM }}
                            </div>
                            <div class="info-value-label" >
                                {{ downloadInfo.updateTime }}
                            </div>
                        </div>
                    </van-skeleton>
                </div>
                <!-- 二维码 -->
                <qrcode
                    class="qrcode" id="qrcode"
                    :value="qrcodeurl"
                    :options="{ size: 170}"
                ></qrcode>
                <!-- ios会提示 未受信任的企业级开发者 -->
                <div v-if="trustTip" class="trust-tip">
                    <a href="#" @click.prevent="showTrustTip">"未受信任的企业级开发者"的解决办法</a>
                </div>

                <div class="install-btn">
                    <transition name="install">
                        <van-button
                            v-show="!isLoading && !isDownLoad"
                            basic
                            @click="toInstall"
                            :class="isLoading ? 'change' : ''"
                        >
                            点击安装
                        </van-button>
                    </transition>
                    <transition name="loading">
                        <van-loading v-show="isLoading" size="44px" vertical color="#3c80e6"></van-loading>
                    </transition>
                    <!-- 正在安装提示 -->
                    <div v-if="isDownLoad" class="loading-tip">
                        <span>
                            {{
                                showInstallText === 'ios'
                                    ? '正在安装，请按 Home 键在桌面查看'
                                    : '正在下载，请在浏览器中查看下载进度'
                            }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="scan-me">或用手机二维码扫码安装</div>
        </div>
        <div class="bottom ignore">
            <span>国泰新点软件股份有限公司版权所有</span>
        </div>

        <!-- 未信任的弹窗 -->
        <van-popup
            v-model="showTrustPop"
            class="trust-pop ignore"
            round
            :close-on-click-overlay="false"
            :lockScroll="false"
        >
            <van-panel title="" desc="" status="">
                <template #header>
                    <div class="trust-header">
                        <span>"未受信任的企业级开发者"的解决办法</span>
                        <van-icon @click="showTrustPop = false" name="cross" />
                    </div>
                </template>
                <div class="trust-content">
                    <div class="top-tip">
                        <span>
                            因苹果公司的政策原因，在iOS系统中首次安装企业版应用时会出现"未受信任的企业级开发者"提示
                        </span>
                        <img src="./images/step-tip.png" />
                        <div>解决办法如下 (以iOS11系统为例) :</div>
                    </div>
                    <div class="step">
                        <span>1、在手机中打开设置功能，选择"通用"</span>
                        <img src="./images/step-1.jpg" />
                    </div>
                    <div class="step">
                        <span>2、在通用中，选择"描述文件与设备管理"功能</span>
                        <img src="./images/step-2.jpg" />
                    </div>
                    <div class="step">
                        <span>
                            3、在描述文件与设备管理中的企业级应用分类中，选择要安装的企业应用的文件名称（与打开时的提示一致），点击进入
                        </span>
                        <img src="./images/step-3.jpg" />
                    </div>
                    <div class="step">
                        <span>
                            4、进入企业签名页面后，确认企业签名中的公司名称与应用名称后，点击信任"企业签名公司名称"
                        </span>
                        <img src="./images/step-4.1.jpg" />
                        <img src="./images/step-4.2.jpg" />
                    </div>
                    <div class="step">
                        <span>5、回到桌面，重新打开应用即可</span>
                    </div>
                </div>
            </van-panel>
        </van-popup>

    </div>
</template>

<script>

import { Button as vanButton, Dialog } from 'vant';
import { Loading as vanLoading } from 'vant';
import { Popup as vanPopup } from 'vant';
import { Panel as vanPanel } from 'vant';
import { Icon as vanIcon } from 'vant';
import { Overlay as vanOverlay} from 'vant';
import { Skeleton as vanSkeleton} from 'vant';
// import QRCodeTools from '@utils/qrcode';
import QRcode from '@chenfengyuan/vue-qrcode';

export default {
  components: {
        vanButton,
        vanLoading,
        vanPopup,
        vanPanel,
        vanIcon,
        vanSkeleton,
        qrcode: QRcode
  },
  data() {
    return {
        isH5Tip: false, //提示当前属于PC端
        trustTip: true, //提示未信任
        showTrustPop: false, // 未信任弹窗
        isLoading: false,
        isDownLoad: false, //安装按钮
        showtoInstall: false, //安装弹窗
        openMobileBrowsers: false, //请打开手机浏览器
        downloadInfo: {}, //请求App信息
        showInstallText: '' ,//苹果安装或安卓浏览器安装
        qrcodeurl:window.location.href,
        donwloadInfoPosting:true,
    };
  },
  methods: {
    onChange(){},
        // 生成二维码
        getQrCode(qrcode) {
            
        },
        // 获取app信息
        getDownLoadInfo(distid) {
            let _that = this;
            this.$http.post({
                method: "/mqms/iosdist/getdownloadinfo",
                params: {
                    id: distid
                },
                success: function(data) {
                    let json = data;
                    _that.downloadInfo = {
                        version:json.version,
                        name:json.name,
                        iconurl:json.iconurl,
                        RAM:_that.sizeTostr(json.size),
                        updateTime:new Date(json.time).format("yyyy-MM-dd"),
                        downloadurl:json.downloadurl
                    };
                    _that.donwloadInfoPosting = false;
                },
                failure(code, msg) {
                    Dialog.alert({
                            title: '提示',
                            message: msg || "信息获取失败",
                    });
                }
            });
        },
        // 未信任的提示
        showTrustTip() {
            this.showTrustPop = true;
        },
        // 点击安装
        toInstall() {
            if ((this.downloadInfo.downloadurl||"").length <= 0) {
                Dialog.alert({
                    title: '提示',
                    message: "无下载信息",
                });
                return ;
            }
            this.isLoading = true;
            setTimeout(()=>{
                this.showtoInstall = true;
                this.isDownLoad = true;
                this.isLoading = false;
            },3000)
            window.location.href = this.downloadInfo.downloadurl;
            //     // 安装提示 , 点击确定调用 installApp 方法安装
            //     this.showInstallText = ios ? 'ios' : 'android';
            //     this.isLoading = !this.isLoading;
        },

        // 确定安装，调用安装接口
        installApp() {
            // Util.ajax({
            //     url: '/rest/mock/download',
            //     success: (result) => {
            //         if (result.status.code === 1) {
            //             this.isDownLoad = true;
            //             this.isLoading = !this.isLoading;
            //         }
            //     }
            // });
        },
        // 取消安装
        cancleInstall() {
            this.isLoading = !this.isLoading;
            this.isDownLoad = false;
        },

        sizeTostr(size) {
            var data = "";
            if (size < 1 * 1024) { //如果小于0.1KB转化成B  
                data = size.toFixed(2) + "B";
            } else if (size < 1 * 1024 * 1024) {//如果小于0.1MB转化成KB  
                data = (size / 1024).toFixed(2) + "KB";
            } else if (size < 1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB  
                data = (size / (1024 * 1024)).toFixed(2) + "MB";
            } else { //其他转化成GB  
                data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
            }
            var sizestr = data + "";
            // eslint-disable-next-line no-useless-escape
            var len = sizestr.indexOf("\.");
            var dec = sizestr.substr(len + 1, 2);
            if (dec == "00") {//当小数点后为00时 去掉小数部分  
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
            }
            return sizestr;
        } 
  },
  mounted() {
    let query = this.$route.query || {};
    let distid = query.id || "";
    if (distid.length <= 0) {
        Dialog.alert({
            title: '提示',
            message: '缺少必要的参数 id',
        });
        return ;
    }
    this.getDownLoadInfo(distid);
    
  },
};

Date.prototype.format = function (format) {
        /*
        * eg:format="YYYY-MM-dd hh:mm:ss";
        */
        var o = {
            "M+": this.getMonth() + 1,  //month
            "d+": this.getDate(),     //day
            "h+": this.getHours(),    //hour
            "m+": this.getMinutes(),  //minute
            "s+": this.getSeconds(), //second
            "q+": Math.floor((this.getMonth() + 3) / 3),  //quarter
            "S": this.getMilliseconds() //millisecond
        };

        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        }

        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
};
</script>
<style lang="scss" scoped>
@import './css/index.scss';
</style>
